import { render, staticRenderFns } from "./productSlider.vue?vue&type=template&id=b71ad66a&scoped=true&"
import script from "./productSlider.vue?vue&type=script&lang=js&"
export * from "./productSlider.vue?vue&type=script&lang=js&"
import style0 from "./productSlider.vue?vue&type=style&index=0&id=b71ad66a&scoped=true&lang=css&"
import style1 from "./productSlider.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71ad66a",
  null
  
)

export default component.exports